<template>
  <RfBaseCard class="aws-marketplace-card mx-auto w-full">
    <div class="flex items-center gap-5">
      <img class="h-6 max-w-max" alt="Recurly Engage logo" src="../assets/images/engage.svg" />
      <img
        class="aws-logo-img ml-auto"
        alt="AWS Logo"
        src="https://assets.redfastlabs.com/images/logo/aws_marketplace.png"
      />
    </div>

    <div
      v-if="errorFormSubmission"
      class="response-msg text-vermillion-50 text-heading-2 mx-auto text-center"
    >
      {{ status }}
      <div class="pt-5">
        <RfButtonNew type="main" size="large" @click="errorFormSubmission = false"
          >Try again</RfButtonNew
        >
      </div>
    </div>
    <div
      v-else-if="formSubmitted"
      class="response-msg success-msg mx-auto text-lg"
      v-html="status"
    />
    <div v-else class="px-5">
      <form class="mx-auto flex max-w-lg flex-col gap-8 pt-10" @submit.prevent="newAccount">
        <RfInput
          v-model="name"
          title="Name"
          requiredTitle
          variant="outlined"
          name="name"
          autocomplete="name"
          autofocus
          placeholder="e.g.: Paul Smith"
          :errorMessage="nameError"
        />
        <RfInput
          v-model="email"
          title="Email address"
          requiredTitle
          variant="outlined"
          name="email"
          type="email"
          autocomplete="email"
          placeholder="e.g: paul@company.com"
          :errorMessage="emailError"
        />
        <RfInput
          v-model="company"
          title="Company name"
          requiredTitle
          variant="outlined"
          name="company"
          autocomplete="organization"
          placeholder="e.g: Company Inc."
          :errorMessage="companyError"
        />
        <div class="pb-20 text-center">
          <RfButtonNew type="main" size="x-large" nativeType="submit">Setup account</RfButtonNew>
        </div>
      </form>
    </div>
  </RfBaseCard>
  <div class="need-help pt-10 text-center">
    Need help? <a href="mailto:support@recurly.com">support@recurly.com</a>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
import * as Sentry from "@sentry/vue";
import { ApiBaseUrl, apiFetch } from "@/apis/fetch";
import RfInput from "@/components/inputs/RfInput.vue";
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";
import RfBaseCard from "@/components/cards/RfBaseCard.vue";

const route = useRoute();
const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const status = ref(null);
const name = ref("");
const email = ref("");
const company = ref("");
const formSubmitted = ref(false);
const errorFormSubmission = ref(false);

const nameError = ref("");
const emailError = ref("");
const companyError = ref("");

const validateForm = () => {
  nameError.value = name.value.trim() ? "" : "Name is required";
  emailError.value = !email.value.trim()
    ? "Email is required"
    : emailPattern.test(email.value.trim())
      ? ""
      : "Invalid email address";
  companyError.value = company.value.trim() ? "" : "Company name is required";

  return !nameError.value && !emailError.value && !companyError.value;
};

const newAccount = async () => {
  if (!validateForm()) return;

  const body = {
    token: route.params.token,
    name: name.value.trim(),
    email: email.value.trim(),
    company: company.value.trim(),
  };

  apiFetch(`${ApiBaseUrl}aws_marketplace`, {
    method: "POST",
    body,
    anon: true,
    onResponse: res => {
      if (res.ok) {
        formSubmitted.value = true;
        errorFormSubmission.value = false;
        status.value =
          "<h3>Thank you!</h3> We've received your information and will get back to you as soon as possible.";
        return;
      }
      errorFormSubmission.value = true;
      status.value = "Something went wrong.";
    },
  }).catch(e => {
    Sentry.captureException(e);
  });
};
</script>

<style scoped>
.aws-marketplace-card {
  max-width: 920px;
  margin-top: 100px;
}
.aws-logo-img {
  max-width: 270px;
}
.response-msg {
  max-width: 32rem;
  padding: 1.25rem;
}
.success-msg {
  margin-bottom: 100px;
}
.need-help {
  padding-bottom: 100px;
}
</style>
